/* =========================================================================
   Salwar Mahal — swipeable product-card gallery (Kalki-style).

   Markup is in snippets/card-product.liquid; styling in assets/quick-add.css.
   The HEAVY LIFTING is done by NATIVE CSS scroll-snap + real <a> slides:
     - swipe  -> the browser scrolls the .sm-gallery__track (scroll-snap)
     - tap    -> the <a class="sm-gallery__link"> navigates to the product
   So this file does NOT implement swiping or navigation itself (that was the
   fragile part that failed before). It only:
     1. keeps the dot indicator in sync with the current slide
     2. wires the desktop hover arrows
     3. (re)initialises galleries added later (infinite scroll / AJAX)

   Idempotent: guarded so loading it more than once (multiple sections on a
   page each include it) can't create duplicate observers.
   ========================================================================= */
(function () {
  if (window.__smGalleryInit) return;
  window.__smGalleryInit = true;

  function initGallery(g) {
    if (g.dataset.smInit) return;
    g.dataset.smInit = '1';

    var track = g.querySelector('.sm-gallery__track');
    if (!track) return;
    var dots = Array.prototype.slice.call(g.querySelectorAll('.sm-gallery__dot'));
    var prev = g.querySelector('.sm-gallery__arrow--prev');
    var next = g.querySelector('.sm-gallery__arrow--next');

    function slideWidth() {
      return track.clientWidth || 1;
    }
    function currentIndex() {
      return Math.round(track.scrollLeft / slideWidth());
    }
    function syncDots() {
      var i = currentIndex();
      for (var k = 0; k < dots.length; k++) {
        dots[k].classList.toggle('is-active', k === i);
      }
    }

    var raf = null;
    track.addEventListener(
      'scroll',
      function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(syncDots);
      },
      { passive: true }
    );

    // Arrows (desktop only via CSS, but harmless if tapped). stopPropagation so
    // the click doesn't bubble to the card's link overlay and navigate away.
    function go(dir) {
      track.scrollBy({ left: dir * slideWidth(), behavior: 'smooth' });
    }
    if (prev)
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(-1);
      });
    if (next)
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        go(1);
      });

    syncDots();
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-sm-gallery]')
      .forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Catch cards injected later (infinite scroll, filtered collection, etc.)
  var scheduled = false;
  var mo = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll();
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
